import FormPasswordInput from "./FormPasswordInput";

export default FormPasswordInput;
